import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { distinctAgainst } from "src/app/shared/rxjs.pipes";
import { AuthService, InvestigationMetricsTechReviewerService } from "src/app/shared/services";
import {
  manageExpenseReportCategoriesList,
  manageExpenseItemsList,
  manageExpensePurposesList,
  manageTimeEntryTypesList,
  manage,
  manageDocumentTypes,
  manageCarriersList,
  manageCertificationsList,
  manageEvidenceLocationsList,
  manageExpenseItems,
  manageServices,
  manageSubServices,
  manageUserRoles,
  manageUserRolesList,
  manageDocumentTemplatingView,
  manageNefcoOfficeList
} from "../../../../shared/helpers/auth-config/manage.config";

import {
  contacts
} from "../../../../shared/helpers/auth-config/contacts.config";

import {
  geoFireReportByStateAll,
  staff
} from "../../../../shared/helpers/auth-config/staff.config";

import {
  expenseInvestigationExpensesAll,
  expenseInvestigationHours,
  expenseInvestigationMileage,
  timeEntryInvestigationHours
} from "../../../../shared/helpers/auth-config/time-expenses.config";
import {
  companies
} from "../../../../shared/helpers/auth-config/companies.config";
import { evidence } from 'src/app/shared/helpers/auth-config/evidence.config';
import { PermissionActions, } from 'src/app/shared/modules/graphql/constants/permission.constants';
import {
  companyInvestigationAndEvidenceReport,
  companyInvestigationReport,
  investigationTimelogPacing,
  investigationReportTimelog,
  quarterlyUtilizationReport,
  quarterlyHourReport,
  reportSentMetric,
  investigationMetricBasicCharts,
  investigationMetricInvestigator,
  investigationMetricState,
  investigationMetricBillToCompany,
  investigationMetricClientCompany,
  investigationMetricTechReviewer,
  investigationMetricContact,
  investigationMetricRisktype,
  investigationMetricDetermination
} from "src/app/shared/helpers/auth-config/reports.config";
import {
  bookKeepingEvidenceBilling,
  bookKeepingExpenseReports,
  bookKeepingInvoiceList,
  bookKeepingPayroll,
  bookKeepingTimeExpensesEntryListExpensesMileage,
  bookKeepingTimeExpensesEntryListHours,
  bookKeepingTimeExpensesExpensesMileageAccountSummary,
  bookKeepingTimeExpensesHoursAccountSummary,
} from "src/app/shared/helpers/auth-config/bookkeeping.config";

import { investigation } from "src/app/shared/helpers/auth-config/investigations.config";
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';

@UntilDestroy()
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  public authConfig = {
    investigation,
    manageExpenseReportCategoriesList,
    manageExpenseItemsList,
    manageExpensePurposesList,
    manageTimeEntryTypesList,
    manage,
    manageDocumentTypes,
    manageCarriersList,
    manageCertificationsList,
    manageEvidenceLocationsList,
    manageExpenseItems,
    manageServices,
    manageSubServices,
    manageUserRoles,
    manageUserRolesList,
    manageDocumentTemplatingView,
    contacts,
    staff,
    expenseInvestigationExpensesAll,
    expenseInvestigationHours,
    expenseInvestigationMileage,
    timeEntryInvestigationHours,
    companies,
    evidence,
    companyInvestigationAndEvidenceReport,
    companyInvestigationReport,
    investigationTimelogPacing,
    investigationReportTimelog,
    quarterlyUtilizationReport,
    quarterlyHourReport,
    reportSentMetric,
    investigationMetricBasicCharts,
    investigationMetricInvestigator,
    investigationMetricState,
    investigationMetricBillToCompany,
    investigationMetricClientCompany,
    investigationMetricTechReviewer,
    investigationMetricContact,
    investigationMetricRisktype,
    investigationMetricDetermination,
    bookKeepingPayroll,
    bookKeepingInvoiceList,
    bookKeepingExpenseReports,
    bookKeepingTimeExpensesEntryListHours,
    bookKeepingTimeExpensesEntryListExpensesMileage,
    bookKeepingTimeExpensesHoursAccountSummary,
    bookKeepingTimeExpensesExpensesMileageAccountSummary,
    bookKeepingEvidenceBilling,
    geoFireReportByStateAll,
    manageNefcoOfficeList
  };

  public portal = false;

  private _user = null;
  public get user() {
    return this._user;
  }

  constructor(
    public auth: AuthService,
    private router: Router,
    private investigationMetricsTechReviewerService: InvestigationMetricsTechReviewerService,
    private notifications: NotificationsService
  ) { }

  ngOnInit() {
    this.auth.authenticatedUser.pipe(
      untilDestroyed(this),
      distinctAgainst(() => this.user),
    ).subscribe((user) => this._user = user);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.portal = event.url.toLowerCase().includes("portal");
      }
    });

  }

  downloadTechReviewerCSV() {
    this.investigationMetricsTechReviewerService.generateTechReviewerInvestigatorCSV().pipe(
      this.notifications.snackbarPipe("Tech Reviewer - Investigator CSV file has been generated successfully. Please check your inbox after some time"),
      this.notifications.snackbarErrorPipe("Error exporting report; please try again")
    ).subscribe()
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    // Close menus if the click is outside the navigation component
    if (!targetElement.closest('.menu')) {
      this.isMenuOpen = {};
    }

    // Close menus if the click is inside the navigation component
    if (targetElement.closest('.menu-content')) {
      this.isMenuOpen = {};
    }
  }

  isMenuOpen: { [key: string]: boolean } = {};
  toggleMenu(menu: string): void {
    this.isMenuOpen = {};
    this.isMenuOpen[menu] = !this.isMenuOpen[menu];
  }
}
